'use strict';

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
}); // eslint-disable-next-line no-unused-vars

exports["default"] = function (theme) {
  return {
    tableBody: {
      '& > .scTableRowContainer:last-child .scTableRowDivider': {
        display: 'none'
      }
    }
  };
};